import { useResources } from '@/hooks/use-resources';
import { EnumScreenName } from '@calm/evexia-analytics';
import ResourceCard from '@rhg/components/resources/resource-card';
import { Box } from '@rhg/libs/material';
import { formatDataForActionSheet } from '@rhg/utils/resources';

interface ResourcesCarouselListProps {
    themes?: string[];
    setActionDialogData: (data: any) => void;
    source?: EnumScreenName;
    partnerDisplayName?: string;
}

function ResourcesCarouselSmartList({
    themes,
    setActionDialogData,
    source,
    partnerDisplayName,
}: ResourcesCarouselListProps) {
    const { resources } = useResources({
        themes,
        shouldLimitResourcesPerTheme: true,
    });

    return (
        <Box data-testid="resources-carousel-smart-list">
            {resources?.map((resource) => {
                return (
                    <ResourceCard
                        key={resource.id}
                        variant="banner"
                        resource={resource}
                        onClick={() =>
                            setActionDialogData(
                                formatDataForActionSheet(
                                    resource,
                                    source,
                                    partnerDisplayName
                                )
                            )
                        }
                    />
                );
            })}
        </Box>
    );
}

export default ResourcesCarouselSmartList;
